import { PageHeader } from "../../components/pages/page-header/PageHeader";
import { MyH1 } from "../../components/UI/my-h1/MyH1";
import { useColors } from "../../hooks/colors/useColors";
import { Container } from "../../components/UI/container/Container";
import { PricingList } from "../../components/pages/pricing/PricingList";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { isPhone } from "../../constants/env";
import { MyHead } from "../../components/pages/MyHead";
import { Fragment } from "react";
import { Footer } from "../../components/pages/homepage/footer/Footer";
import { useSpecialistList } from "../../hooks/react-query/useSpecialistList";

// @ts-ignore
export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
      // Will be passed to the page component as props
    },
  };
}

function ContactPage() {
  const { colors } = useColors();
  const { t } = useTranslation("common");
  const { specialists } = useSpecialistList();

  return (
    <Fragment>
      <MyHead title={t("pricing")} description={t("pricing-app")} />
      <PageHeader>
        <MyH1
          size={isPhone ? "2.5rem" : "3rem"}
          color={colors.white}
          className="text-center"
        >
          {t("pricing-app")}
        </MyH1>
      </PageHeader>
      <div style={{ backgroundColor: colors.background }}>
        <Container noHeight>
          <PricingList />
        </Container>
      </div>
      <Footer isVisible={typeof specialists !== "undefined"} delay />
    </Fragment>
  );
}

export default ContactPage;
